import {get, post} from '@utils/baseRequest';
import {host} from '@utils/hostConf';
import {stores} from '../index';

export async function fetchDeal(data) {
  const res = await get({
    url: host.cplus + 'cgi-bin/deal/getDeal',
    data,
  });

  stores.dealStore.setDeal(res);
  return res;
}

//取消订单
export function reqCancelDeal(data) {
  return post({
    url: host.cplus + 'cgi-bin/deal/cancel',
    data: {
      ...data,
      request_source: '17',
    },
  });
}

export function fetchSmsWxPay(data) {
  return post({url: `${host.cplus}cgi-bin/pay/request`, data});
}

export function registDetail(data) {
  return get({url: `${host.goapi}omo/deal/registDetail`, data})
}

/**
 * 用户看诊内容（评价用）
 * @param {*} user_id 
 * @param {*} deal_id 
 * @returns 
 */
export function queryDealPropery(data) {
  return get({url: `${host.goapi}comment/handler/QueryDealPropery`, data})
  // return get('/goapi/comment/handler/QueryDealPropery', data)
}

/**
 * 订单详情 (预约单id+用户id || 挂号单id+用户手机号)
 * @param user_id （用户id || 用户手机号）
 * @param deal_id
 */
export const queryDeal = (data) =>  {
  return get({url: `${host.goapi}deal/handler/QueryDeal`, data})
}

/**
 * 订单详情
 * @param {Object} data 
 * @param {Object} data.user_id
 * @param {Object} data.deal_id
 * @returns 
 */
export const querySimpleDealDetail = (data) =>  {
  return get({url: `${host.goapi}deal/handler/QuerySimpleDealDetail`, data})
}